<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42.5 41H41v-4a2 2 0 00-2-2h-1V22h4a2 2 0 001.22-3.58l-18-13.87a2 2 0 00-2.44 0l-18 13.87A2 2 0 006 22h4v13H9a2 2 0 00-2 2v4H5.5a1.5 1.5 0 000 3h37a1.5 1.5 0 000-3zM35 35h-4V22h4zM23 22v13h-4V22zm2 0h4v13h-4zM24 7.39L39.09 19H8.91zM13 22h4v13h-4zm-3 19v-3h28v3z"/><path d="M24 11.5a3 3 0 103 3 3 3 0 00-3-3zm0 4a1 1 0 111-1 1 1 0 01-1 1z"/></svg>